/**
 * FlahaSOIL v2 — ReportSection (Phase 10D).
 *
 * Layout wrapper for report sections with integrated headers and page-break logic.
 */
import { Box, Typography, Divider, Stack } from "@mui/material";
import { flahaSoilColors } from "../../../../theme/flahaSoilTheme";

export interface ReportSectionProps {
  id: string;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  action?: React.ReactNode;
  noBreak?: boolean;
}

export function ReportSection({
  id,
  title,
  subtitle,
  children,
  action,
  noBreak = false,
}: ReportSectionProps) {
  return (
    <Box
      id={id}
      className={`report-section${noBreak ? " no-break" : ""}`}
      sx={{
        mt: 4,
        mb: 2,
        breakInside: noBreak ? "avoid" : "auto",
        "&:first-of-type": { mt: 0 },
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-end"
        sx={{ mb: 1 }}
      >
        <Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: flahaSoilColors.deepSoilBrown,
              textTransform: "uppercase",
              letterSpacing: "0.1em",
              fontSize: "1rem",
            }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="caption" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Box>
        {action}
      </Stack>
      <Divider sx={{ mb: 2, borderColor: flahaSoilColors.divider, borderBottomWidth: 2 }} />
      <Box sx={{ pl: { xs: 0, sm: 2 } }}>
        {children}
      </Box>
    </Box>
  );
}
